import { useSlots as y, inject as s, computed as g, createElementBlock as l, openBlock as r, normalizeClass as d, unref as t, createBlock as i, resolveDynamicComponent as S, withCtx as u, renderSlot as p, provide as c } from "vue";
import { _ as f } from "./DIcon.js";
import { _ as k } from "./DButton.js";
import "../vendor/@iconify_vue@5.0.0_vue@3.5.18_typescript@5.7.2_.js";
const v = {
  key: 1,
  class: "w-5 h-5 flex items-center justify-center",
  "data-test": "separator-icon"
}, L = {
  __name: "DBreadcrumb",
  props: {
    href: {
      type: String,
      default: null,
      description: "Href for navigation."
    },
    target: {
      type: String,
      default: null,
      description: "Target attribute for the link."
    },
    tag: {
      type: String,
      default: "a",
      description: "HTML tag or router-link for the breadcrumb item."
    },
    icon: {
      type: String,
      default: "home",
      description: "Icon for the breadcrumb.",
      iconify: !0
    },
    iconType: {
      type: String,
      default: "small",
      description: "Type of icon for the breadcrumb.",
      deprecated: "Use icon prop with full iconify icon string"
    },
    iconSet: {
      type: String,
      description: "Icon set for the breadcrumb.",
      deprecated: "Use icon prop with full iconify icon string"
    },
    to: {
      type: [String, Object],
      description: "Route location for navigation."
    },
    separatorIcon: {
      type: String,
      description: "Icon for the separator.",
      iconify: !0
    },
    separatorIconSet: {
      type: String,
      description: "Icon set for the separator.",
      deprecated: "Use icon prop with full iconify icon string"
    },
    color: {
      type: String,
      default: "base",
      description: "Color theme for the breadcrumb."
    },
    slashSeparator: {
      type: Boolean,
      default: !1,
      description: "Use slash as separator instead of icon."
    }
  },
  setup(e) {
    const o = y(), a = s("color", "base"), n = s("iconSet", "heroicons"), b = s("slashSeparator", !1), h = g(() => n === "heroicons" ? "chevron-right" : "caret-right");
    return (m, w) => (r(), l("div", {
      class: d(["flex items-center gap-x-0.5", {
        "button-transparent-on-surface-neutral-default hover:button-transparent-on-surface-neutral-hover active:button-transparent-on-surface-neutral-active": t(a) === "base",
        "button-transparent-on-surface-brand-default hover:button-transparent-on-surface-brand-hover active:button-transparent-on-surface-brand-active": t(a) === "brand"
      }]),
      "data-spark": "dbreadcrumb"
    }, [
      t(b) ? (r(), l("span", v, " / ")) : (r(), i(f, {
        key: 0,
        icon: t(h),
        "icon-set": t(n),
        type: t(n) === "heroicons" ? "small" : "bold",
        "data-test": "separator-icon",
        size: "w-5 h-5"
      }, null, 8, ["icon", "icon-set", "type"])),
      (r(), i(S(e.tag), {
        to: e.to,
        href: e.href,
        target: e.target,
        class: d(["group", {
          "cursor-pointer": e.href || e.to
        }]),
        "aria-label": t(o).default ? null : "home"
      }, {
        default: u(() => [
          t(o).default ? (r(), i(k, {
            key: 1,
            theme: "text-link",
            "link-underline": !1,
            disabled: !e.href && !e.to,
            "link-color": !e.href && !e.to ? "base" : t(a)
          }, {
            default: u(() => [
              p(m.$slots, "default")
            ]),
            _: 3
          }, 8, ["disabled", "link-color"])) : (r(), i(f, {
            key: 0,
            icon: e.icon,
            type: e.iconType,
            "icon-set": e.iconSet,
            "data-test": "leading-icon",
            size: "w-5 h-5"
          }, null, 8, ["icon", "type", "icon-set"]))
        ]),
        _: 3
      }, 8, ["to", "href", "target", "class", "aria-label"]))
    ], 2));
  }
}, T = {
  __name: "DBreadcrumbs",
  props: {
    color: {
      type: String,
      default: "base",
      description: "Color theme for the breadcrumbs."
    },
    iconSet: {
      type: String,
      default: "heroicons",
      description: "Icon set for the breadcrumbs."
    },
    slashSeparator: {
      type: Boolean,
      default: !1,
      description: "Use slash as separator instead of icon."
    },
    topLine: {
      type: Boolean,
      default: !1,
      description: "Show top border line."
    },
    bottomLine: {
      type: Boolean,
      default: !1,
      description: "Show bottom border line."
    }
  },
  setup(e) {
    const o = e;
    return c("color", o.color), c("iconSet", o.iconSet), c("slashSeparator", o.slashSeparator), (a, n) => (r(), l("div", {
      class: d(["flex items-center gap-x-0.5 py-6", {
        "border-t border-border-neutral-subtle": e.topLine,
        "border-b border-border-neutral-subtle": e.bottomLine
      }]),
      "data-spark": "dbreadcrumbs"
    }, [
      p(a.$slots, "default")
    ], 2));
  }
};
export {
  L as _,
  T as a
};
